import { defineMessages } from 'react-intl';
import VehicleInfo from '@/pages/home/[type]/quote/vehicle-info';
import TravelInfo from '@/pages/home/[type]/quote/travel-info';
import PaInfo from '@/pages/home/[type]/quote/pa-info';
import HcInfo from '@/pages/home/[type]/quote/hc-info';

export const FIRST_STEP: { [prop: string]: any } = {
  motor: {
    title: defineMessages({
      Vehicle: { id: 'Vehicle' },
    })['Vehicle'],
    Component: VehicleInfo,
    key: 'motor',
  },
  pd: {
    title: defineMessages({
      Vehicle: { id: 'Vehicle' },
    })['Vehicle'],
    Component: VehicleInfo,
    key: 'motor',
  },
  travel: {
    title: defineMessages({
      Travel: { id: 'Travel Details' },
    })['Travel'],
    Component: TravelInfo,
    key: 'travel',
  },
  pa: {
    title: defineMessages({
      Pa: { id: 'Policy Details' },
    })['Pa'],
    Component: PaInfo,
    key: 'pa',
  },
  health: {
    title: defineMessages({
      Health: { id: 'Policy Details' },
    })['Health'],
    Component: HcInfo,
    key: 'health',
  },
};
